export const NAV_ITEMS = [
  'family-history',
  'familysearch',
  'family-tree',
  'wall-art',
  'photo-prints',
  'photo-books',
  'calendars',
  'display',
  'giftcard',
];

export const FAVORITE_PRODUCTS = [
  'ancestry-book',
  'ancestry-poster',
  'ancestry-calendar',
  'artprint',
  'softcover-books',
];

export const FAVORITE_CATEGORIES = ['family-history', 'photo-books', 'display', 'wall-art'];

export const NEW_PRODUCTS = [
  'family-flip',
  'glossy-prints',
  'metal-wall-prints',
  'acrylic-magnets',
];

export const MIGHT_LIKE_PRODUCTS = [
  'metal-desk-prints',
  'metal-wall-prints',
  'ancestry-book',
  'ancestry-poster',
  'engineer-prints',
  'artprint',
  'softcover-books',
  'wooden-rails',
  'wall-calendar',
];
